
import React from "react";
import { Schemes, Utils } from "../../../../../utils";
import { i18nManager } from "../../../../../i18n";
import { Elements } from "../../../../shared/Elements";
import { Siren } from "../../../../shared/ConfirmDialog";
import * as ReactRouterDom from "react-router-dom";
import LoadingGif from "../../../../assets/images/loading_circle.gif";
import { BaseService, HostService, IHost, IHostWebsite, IMember, IProfileWebsite, ITeam, MemberService, SanitizedResponse } from "../../../../../services";
import { Button, Checkbox, ComposedPassword, DateTimeInput, DateTimePicker, DOMHelper, Dropdown, Form, FormControl, NoseurObject, ObjectHelper, TabPane, TabPanel, TextAreaInput, TextInput } from "@rivtn/noseur";
import ImportExport from "../../../../page_design/ImportExport";
import MediaInput, { MediaInputManageRef } from "../../../../shared/MediaInput";

export interface VisibilitiesProps {
    host: IHost;
    profile: IMember;
    hostWebsite: IHostWebsite;
}

function Visibilities(props: VisibilitiesProps) {

    const { host } = props;
    const hostService = HostService.getInstance();
    const [init, setInit] = React.useState<boolean>(false);
    const [profile, _] = React.useState<IMember>(props.profile);
    const labels = i18nManager.Labels.host.settings.about.visibilities;
    const mediaInputManageRef = React.useRef<MediaInputManageRef>(null);
    const [hostWebsite, setHostWebsite] = React.useState<IHostWebsite>(props.hostWebsite);
    
    React.useEffect(() => {
        if (!init) {
            setInit(true);
            return;
        }
        updateHostWebsite();
    }, [hostWebsite]);

    return (<Form scheme={Schemes.OMNEHOST} className="profile-settings team-settings" style={{ padding: 0, boxShadow: "none" }}>
        <Checkbox label={labels.enable_ad} defaultChecked={hostWebsite.about_settings.enable_rivtn_ad} onChecked={(checked) => {
            setHostWebsite({ ...hostWebsite, about_settings: { ...hostWebsite.about_settings, enable_rivtn_ad: checked } });
        }} />
        <hr />
        <Checkbox label={labels.show_people} defaultChecked={hostWebsite.about_settings.show_people} onChecked={(checked) => {
            setHostWebsite({ ...hostWebsite, about_settings: { ...hostWebsite.about_settings, show_people: checked } });
        }}/>
        <Checkbox label={labels.show_addr} defaultChecked={hostWebsite.about_settings.show_physical_address} onChecked={(checked) => {
            setHostWebsite({ ...hostWebsite, about_settings: { ...hostWebsite.about_settings, show_physical_address: checked } });
        }} />
        <Checkbox label={labels.show_contact_phone_emails} defaultChecked={hostWebsite.about_settings.show_contact_emails_and_phones} onChecked={(checked) => {
            setHostWebsite({ ...hostWebsite, about_settings: { ...hostWebsite.about_settings, show_contact_emails_and_phones: checked } });
        }} />
        <Checkbox label={labels.show_sponsors} defaultChecked={hostWebsite.about_settings.show_sponsors} onChecked={(checked) => {
            setHostWebsite({ ...hostWebsite, about_settings: { ...hostWebsite.about_settings, show_sponsors: checked } });
        }} />
    </Form>);

    function updateHostWebsite() {
        hostService.updateHostWebsite(host.external_id, { ...hostWebsite }).then(({ }: SanitizedResponse<IHostWebsite>) => {
            Siren.alert(labels.update_successful);
        }).catch(BaseService.reportError);
    }

}

export default Visibilities;
